import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum FeatureType {
  COMMENT_NOTES = 'comment-notes',
  MORE_SEARCH_PROFILES = 'more-search-profiles',
  EXCEL_EXPORT = 'excel-export',
  ICAL_EXPORT = 'ical-export',
  TENDER_ACCESS = 'tender-access',
  MORE_SEARCH_RESULTS = 'more-search-results',
  MORE_SEARCH_REQUESTS = 'more-search-requests',
  GEO_FILTERING = 'geo-filtering',
  QUICK_COPY = 'quick-copy',
  EXTENDED_DESCRIPTION = 'extended-description',
  FAVORITES_EXCEL_EXPORT = 'favorites-excel-export',
  SEARCH_INDICATOR = 'search-indicator',
  MORE_TEAM_MEMBERS = 'more-team-members',
  MORE_CHAT_MESSAGES = 'more-chat-messages',
  MORE_WEBHOOKS = 'more-webhooks',
}

interface ModalState {
  isOpen: boolean;
  featureType: FeatureType | null;
}

const initialState: ModalState = {
  isOpen: false,
  featureType: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalState['featureType']>) => {
      state.isOpen = true;
      state.featureType = action.payload;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.featureType = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
